import React from "react";
import { BsPlus } from "@react-icons/all-files/bs/BsPlus";
import { TranslatableString, } from "@rjsf/utils";
import { clsx } from "clsx";
import Button from "./Button";
export default function AddButton({ uiSchema, registry, ...props }) {
    const { translateString } = registry;
    return (React.createElement(Button, { variant: "default", size: "sm", ...props, className: clsx(props.className), title: translateString(TranslatableString.AddItemButton) },
        React.createElement(BsPlus, null)));
}
//# sourceMappingURL=AddButton.js.map